import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import { Store } from 'vuex';
import { sync } from 'vuex-router-sync';
import Meta from 'vue-meta';
import VueLazyload from 'vue-lazyload';
import Vuelidate from 'vuelidate';
import App from './components/App.vue';
import store from './store';
import IRootState from './store/types/IRootState';
import router from './router';
import i18n from './i18n';
import { EventBusPlugin, HttpServicePlugin, ConfigPlugin } from './plugins';
import { Localisable } from './mixins';
import { attachGuards } from '@/router/helpers';

Vue.use(Vuelidate);
Vue.use(VueLazyload);
Vue.use(Meta);
Vue.use(ConfigPlugin);
Vue.use(EventBusPlugin);
Vue.use(HttpServicePlugin);
Vue.mixin(Localisable);

export interface IApplication {
  app: Vue;
  router: VueRouter;
  store: Store<IRootState>;
  i18n: VueI18n;
}

export const createApplication = (): IApplication => {
  sync(store, router);
  attachGuards(router, store);

  const app: Vue = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  });

  return { app, router, store, i18n };
};
